import moment from 'moment';

import {assert} from 'Asserts';
import {prependAOrAn} from 'BenchlingUtil';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys} from 'procedures/ProceduresStringKeys';
import {getProcedureTypeForStudyType, getStudyTypeText} from 'studies/TypedStudyUtils';
import * as DateUtil from 'util/DateUtil';

import {StudyListingGraphQL} from '../../../../../graphql-fragments/studies/__generated/StudyListingGraphQL';

export const CREATE_ANALYSIS_NO_PERMISSION_MESSAGE =
  'You do not have sufficient permissions to create an analysis. Please contact your administrator.';

export function getCannotCreateAnalysisMessageForStudyType(studyType: StudyType): string {
  const studyTypeText = getStudyTypeText(studyType);
  const applicationName = getProcedureUIString(
    ProceduresStringKeys.PROCEDURE,
    getProcedureTypeForStudyType(studyType),
    {plural: true}
  );
  return `Analyzing ${prependAOrAn(studyTypeText)} study requires access to the ${applicationName} application. Contact your administrator for access.`;
}
export const NO_PROCEDURE_RUNS_TO_ANALYZE_MESSAGE = 'No runs available to analyze yet.';

/**
 * Returns the initial analysis name to use in the create analysis modal for analysis of a study.
 *
 * @param studyName The name of the study.
 */
export function getInitialAnalysisNameForStudy(studyName: string): string {
  return `${studyName}_${DateUtil.readableTime(moment(), {
    showTime: true,
  })}`;
}

/**
 * Returns the initial analysis name to use in the create analysis modal for cross-study analysis.
 *
 * @param selectedStudies The studies to be analyzed.
 */
export function getInitialAnalysisNameForCrossStudyAnalysis(
  selectedStudies: Array<StudyListingGraphQL>
): string {
  assert(selectedStudies.length > 0, 'Expected multiple studies to be selected.');
  const firstStudyName = selectedStudies[0].name;
  const timestamp = DateUtil.readableTime(moment(), {showTime: true});
  if (selectedStudies.length === 1) {
    return `${firstStudyName}_${timestamp}`;
  }
  return `${firstStudyName}_and_${selectedStudies.length - 1}_others_${timestamp}`;
}
